import { Component } from '@angular/core';
import { isAdmin, isInternalRegional } from '@era/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { map, Observable } from 'rxjs';
import { ForceSyncService } from './device-mdm-sync-force.service';
import { DeviceMdmSyncForceComponent } from './device-mdm-sync-force.component';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'era-device-mdm-sync-force',
  templateUrl: './device-mdm-sync-force.container.html',
  styleUrls: ['./device-mdm-sync-force.container.scss'],
  imports: [DeviceMdmSyncForceComponent, AsyncPipe],
})
export class DeviceMdmSyncForceContainerComponent {
  public readonly isAuthorized$: Observable<boolean>;

  constructor(
    private readonly oidcService: OidcSecurityService,
    private forceSyncService: ForceSyncService
  ) {
    this.isAuthorized$ = this.oidcService.userData$.pipe(map((data) => isAdmin(data) || isInternalRegional(data)));
  }

  updateForceSync(forceSync: boolean): void {
    this.forceSyncService.setForceSync(forceSync);
  }
}
